import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import {
	buildLeavePolicyComboPayload,
	mapComboApiToPolicy,
} from "../../../../components/leavePolicy/leavePolicyComboMapper";

export const leavePolicyComboSetup = createAsyncThunk(
	"leavePolicy/leavePolicyComboSetup",
	async ({ leavePolicyId, policy }, { rejectWithValue }) => {
		try {
			const { data } = await axios.post(
				`leave/LeavePolicyComboSetup`,
				buildLeavePolicyComboPayload(leavePolicyId, policy)
			);
			return { data, message: "success" };
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to save combo-off policy. Try again.";
			toast.error(errorMessage);
			return rejectWithValue({ message: "error", error: errorMessage });
		}
	}
);

export const leavePolicyComboGetById = createAsyncThunk(
	"leavePolicy/leavePolicyComboGetById",
	async (leavePolicyId, { rejectWithValue }) => {
		try {
			const { data } = await axios.get(`leave/LeavePolicyComboGetbyId`, {
				params: { LeavePolicyId: leavePolicyId },
			});
			const record = Array.isArray(data) ? data[0] : data;
			if (!record) {
				return { policy: mapComboApiToPolicy(null), rawRecord: null };
			}
			return {
				policy: mapComboApiToPolicy(record),
				rawRecord: record,
			};
		} catch (error) {
			if (error.response?.status === 404) {
				return { policy: mapComboApiToPolicy(null), rawRecord: null };
			}
			return rejectWithValue({
				message: "error",
				error: error.response?.data?.message || error.message,
			});
		}
	}
);
